<template>
  <v-container>
    <v-row justify="center" >
      <v-col cols="12" md="8">
        <v-card elevation="10" class="pa-4">
          <v-card-title>
            <h3 class="mb-0">Regras de permissões</h3>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="lista_roles"
              :items-per-page="perPage"
              :page.sync="currentPage"
              class="elevation-1"
              :footer-props="{
                'items-per-page-options': [10, 20, 50],
                'items-per-page-text': 'Itens por página',
              }"
              :no-data-text="'Nenhum registro encontrado!'"
            >
              <template #item.acoes="{ item }">
                <div class="text-right w-100">
                  <v-tooltip top>
                    <template #activator="{ on, attrs }">
                      <v-btn
                        icon
                        small
                        class="mx-1 d-none"
                        v-bind="attrs"
                        v-on="on"
                        @click.prevent="abrirModalVinculo(item)"
                      >
                        <v-icon color="primary">mdi-account</v-icon>
                      </v-btn>
                    </template>
                    <span>Vincular Usuários</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template #activator="{ on, attrs }">
                      <v-btn
                        fab
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click.prevent="editarRegra(item)"
                      >
                        <v-icon color="primary">mdi-pen</v-icon>
                      </v-btn>
                    </template>
                    <span>Configurações da regra</span>
                  </v-tooltip>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/store/breadcrumbs.module";

export default {
  data() {
    return {
      vincular_usuario_modal: false,
      selectedItem: {},
      currentPage: 1,
      perPage: 10,
      vinculo: {
        role_id: "",
        permission_id: "",
      },
      usuario_id: "",
      vinculacao: 0,
      headers: [
        { text: "ID", value: "id" },
        { text: "Nome", value: "name" },
        { text: "", value: "acoes", sortable: false },
      ],
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Permissoes" }]);
  },
  created() {
    this.get_permisoes_roles();
  },
  computed: {
    lista_roles() {
      return this.$store.state.permissoes.lista_roles;
    },
    lista_roles_permissoes() {
      return this.$store.state.permissoes.lista_roles_permissoes;
    },
  },
  methods: {
    abrirModalVinculo(item) {
      this.vincular_usuario_modal = true;
      this.selectedItem = item;
    },
    editarRegra(value) {
      this.$store.dispatch("configEmpresa/atualizar", value);
      this.$router.push({ name: "createRule" });
    },
    async get_permisoes_roles() {
      await this.$store.dispatch("permissoes/all_roles");
      this.$store.dispatch("configEmpresa/atualizar", "");
    },
    async listar_permissoes_role(value) {
      this.vinculacao = 2;
      this.vinculo.role_id = value.id;
      await this.$store.dispatch("permissoes/all_permissions_regra", value.id);
      await this.$store.dispatch("permissoes/all_permissions");
    },
    async listar_usuarios_role(value) {
      this.vinculacao = 1;
      this.vinculo.role_id = value.id;
      await this.$store.dispatch("permissoes/all_roles");
    },
  },
};
</script>

<style scoped>
/* Add any custom styles if needed */
</style>
